import { render } from "./SystemConfig.vue?vue&type=template&id=0e740dfe&scoped=true"
import script from "./SystemConfig.vue?vue&type=script&lang=js"
export * from "./SystemConfig.vue?vue&type=script&lang=js"

import "./SystemConfig.vue?vue&type=style&index=0&id=0e740dfe&lang=scss&scoped=true"
import "./SystemConfig.vue?vue&type=style&index=1&id=0e740dfe&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e740dfe"]])

export default __exports__